import {drawer} from '@cypro/ui/components'
import {UserDrawer} from '@/modules/users/components/user-drawer/user-drawer'
import {UserProvider} from '@/shared/contexts'
import {User} from '@cypro/engine/schema'
import {Suspense} from 'react'

export function getUserDrawerId(userId: string) {
  return `user-drawer-${userId}`
}

export function openUserDrawer(user: User) {
  const id = getUserDrawerId(user.id)

  try {
    drawer.remove(id)
  } catch {}

  return drawer.open(id, {
    id,
    children: (
      <Suspense>
        {user && (
          <UserProvider user={user}>
            <UserDrawer />
          </UserProvider>
        )}
      </Suspense>
    ),
    contentProps: {
      'data-e2e': 'user-drawer',
    },
  })
}
